import { useCallback, useMemo, useState } from 'react';
import { productApprovalsApi } from '../data/productApprovalsApi';
import { captureException, reportRequestException } from '../utils/sentryUtils';
import { useGetApprovalSkipConfigurationQuery } from '../../__generated__/chirp/com/hubspot/product/approvals/rpc/ApprovalsConfigurationRpc.hooks';
import { useGetIsUngated } from './useGetIsUngated';
import { GATES } from '../constants/auth';
export const useApprovalSkipConfig = (approvalAction, approvalType) => {
  const getIsUngated = useGetIsUngated();
  const isChirpEnabled = getIsUngated(GATES.CHIRP_MIGRATION);
  const [skipConfig, setSkipConfig] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const fetchSkipConfig = useCallback(() => {
    if (isChirpEnabled) return;
    setIsLoading(true);
    productApprovalsApi.fetchSkipConfig(approvalType, approvalAction).then(data => {
      setSkipConfig(data);
    }).catch(errorResponse => reportRequestException('fetchSkipConfig', errorResponse)).finally(() => setIsLoading(false)).catch(() => console.error('Error fetching skip config'));
  }, [approvalAction, approvalType, isChirpEnabled]);
  const {
    data: chirpData,
    loading: chirpLoading,
    refetch: chirpRefetch
  } = useGetApprovalSkipConfigurationQuery({
    variables: {
      approvalType,
      approvalAction
    },
    skip: !isChirpEnabled,
    // fetchPolicy 'network-only' ensures fresh data. If removing this need to test extensively
    fetchPolicy: 'network-only',
    onError: error => {
      captureException(error, {
        extra: {
          fingerprint: 'useApprovalSkipConfig-chirp',
          approvalType,
          approvalAction
        }
      });
    }
  });
  const chirpSkipConfig = useMemo(() => {
    if (!chirpData) return null;
    const {
      approvalSkipConfiguration: {
        skipApprovalOption,
        usersIdsListThatCanSkipApproval
      }
    } = chirpData;
    return {
      skipApprovalOption: skipApprovalOption,
      usersIdsListThatCanSkipApproval
    };
  }, [chirpData]);
  const chirpFetchSkipConfig = useCallback(() => {
    void chirpRefetch();
  }, [chirpRefetch]);
  return useMemo(() => {
    if (isChirpEnabled) {
      return {
        skipConfig: chirpSkipConfig,
        fetchSkipConfig: chirpFetchSkipConfig,
        isLoading: chirpLoading
      };
    }
    return {
      skipConfig,
      fetchSkipConfig,
      isLoading
    };
  }, [isChirpEnabled, chirpSkipConfig, chirpFetchSkipConfig, chirpLoading, skipConfig, fetchSkipConfig, isLoading]);
};